import {
  Injectable,
  OnDestroy,
  PLATFORM_ID,
  inject,
  signal
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const MOBILE_BREAKPOINT = 480;

@Injectable({ providedIn: 'root' })
export class BreakpointService implements OnDestroy {
  /** Signal that is `true` when the viewport width is ≤ 480px */
  readonly isMobile = signal<boolean>(false);

  private readonly platformId = inject(PLATFORM_ID);
  private mql?: MediaQueryList;
  private listener?: () => void;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
      this.isMobile.set(this.mql.matches);
      this.listener = () => this.isMobile.set(this.mql!.matches);
      this.mql.addEventListener('change', this.listener);
    }
  }

  ngOnDestroy(): void {
    if (this.mql && this.listener) {
      this.mql.removeEventListener('change', this.listener);
    }
  }
}
